import { render, staticRenderFns } from "./LoadMoreCard.vue?vue&type=template&id=9aec3e08&scoped=true&lang=pug&"
import script from "./LoadMoreCard.vue?vue&type=script&lang=js&"
export * from "./LoadMoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aec3e08",
  null
  
)

export default component.exports